export default "__VITE_ASSET__75ee9abc__"